import React from 'react';

import { Helmet } from 'react-helmet';

export const ActiveCampaignIntegration = () => {
  return (
    <Helmet>
      {/* New Script for pop-up added as on 16th Nov 2023 */}
      <script src="https://feedmyfurbaby44028.activehosted.com/f/embed.php?id=28" charset="utf-8"></script>
    </Helmet>
  );
};

export default ActiveCampaignIntegration;
